import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/wuhan1.webp',
  './images/wuhan2.webp',
  './images/wuhan3.webp',
  './images/wuhan.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Wuhan, the capital of Hubei Province, is a dynamic metropolis in central China where the Yangtze and Han rivers meet. Known for its lakes, bridges, and rich history, Wuhan blends ancient culture with modern development.

Top places to visit:

• Yellow Crane Tower – A legendary historic tower offering panoramic views of the Yangtze River.
• East Lake Scenic Area – The largest urban lake in China, ideal for cycling, boating, and nature walks.
• Hubei Provincial Museum – A must-visit museum with ancient artifacts, including bronze bells and the Sword of Goujian.
• Wuhan Yangtze River Bridge – The first bridge built over the Yangtze, connecting the city's three towns.
• Han Street – A lively shopping and cultural district with traditional architecture and modern entertainment.
• Guiyuan Temple – A renowned Buddhist temple known for its arhats and peaceful gardens.
• Wuhan University – Famous for cherry blossoms in spring and its beautiful campus architecture.
• Wuhan Botanical Garden – A tranquil garden with plant collections from around the world.
• Tanhualin Historic Area – A quaint street with cafés, murals, and preserved old buildings.
• Happy Valley Wuhan – A large amusement park offering rides and shows for all ages.

Wuhan is also known for its street food and local specialties like hot dry noodles (reganmian), duck neck, and spicy crayfish.`,

    zh: `武汉是湖北省省会，位于中国中部，是长江与汉江的交汇处。这座城市融合了丰富的历史文化与现代都市风貌，以湖泊众多、桥梁壮观著称。

推荐景点：

• 黄鹤楼 – 俯瞰长江的历史名楼，被誉为“江南三大名楼”之一。
• 东湖风景区 – 中国最大的城市湖泊，适合骑行、泛舟和观景。
• 湖北省博物馆 – 收藏丰富的文物，包括越王勾践剑和曾侯乙编钟。
• 武汉长江大桥 – 中国第一座横跨长江的大桥，具有重要交通和历史意义。
• 汉街 – 融合传统与现代的商业街区，集购物、美食与文化于一体。
• 归元禅寺 – 佛教胜地，以五百罗汉堂闻名，环境幽静。
• 武汉大学 – 校园景色优美，春季樱花盛开吸引众多游客。
• 武汉植物园 – 园区分布多种植物主题园区，是亲近自然的好去处。
• 昙华林历史街区 – 保留了众多老建筑，有文艺咖啡馆与特色小店。
• 欢乐谷武汉 – 综合性大型游乐园，适合家庭出游和年轻人娱乐。

武汉的特色小吃也广受欢迎，如热干面、鸭脖和麻辣小龙虾，令人回味无穷。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/wuhan.webp" className="travel-image2" />
          <img src="./images/wuhan1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Wuhan</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Wuhan</h2>
          <p className="carousel-subheading">
            Discover lakeside beauty, cultural heritage, and bold central Chinese flavors.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
